import lrCode from './_src/lrCode.vue'

lrCode.install = function(Vue) {
  Vue.component(lrCode.name, lrCode)
}

export default lrCode